<div class="table-container">
  <table mat-table [dataSource]="list" matSort>

    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "global.code" | translate }} </th>
      <td mat-cell *matCellDef="let item"> {{item.code}} </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"country.kf-configuration.wizard.reporting-group.description" | translate}} </th>
      <td mat-cell *matCellDef="let item"> {{item.description}} </td>
    </ng-container>

    <ng-container matColumnDef="comment">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"country.kf-configuration.wizard.reporting-group.comment" | translate}} </th>
      <td mat-cell *matCellDef="let item"> {{item.comment}} </td>
    </ng-container>

    <ng-container matColumnDef="scope">
      <th mat-header-cell *matHeaderCellDef> {{"country.kf-configuration.wizard.reporting-group.scope?" | translate}} </th>
      <td mat-cell *matCellDef="let item" class="checkbox-cell">
        <mat-checkbox [id]="type + '-' + item.id" color="primary" [checked]="isItemChecked(item)" (change)="onCheckboxChange($event)">
        </mat-checkbox>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator color="primary" [length]="totalElements"
                 [pageSize]="pageSize"
                 (page)="onPageChange($event)"
                 [pageSizeOptions]="pageSizes">
  </mat-paginator>
</div>


